<template>
  <div>
    <el-row>
      <!-- 工具栏 -->
      <el-form
        :inline="true"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
      >
        <el-form-item>
          <el-button
            type="warning"
            plain
            class="el-icon-plus"
            @click="addPersonReduce"
            >添加减免</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table
        :data="tableData"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width: 100%"
      >
        <el-table-column
          prop="userTypeName"
          label="人员类别"
          min-width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in itemOptions"
          :key="index"
          :label="item.title"
          :prop="item.key"
          min-width="150"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" min-width="150" align="center">
          <template slot-scope="scope">
            <!-- <a @click="handleEdit(scope.$index, scope.row)">
              <img
                v-if="scope.row.list.length > 0"
                src="@/assets/beadhouse/xiugai_icon.png"
                class="handedness"
              />
            </a> -->
             <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 添加和修改减免的模态框 -->
    <el-dialog
      :title="operation ? '添加减免' : '修改减免'"
      width="30%"
      :visible.sync="dialogVisiblePersonReduceForm"
      :close-on-click-modal="false"
      @close="closeDialogVisible"
    >
      <el-form
        :model="personReduceForm"
        label-width="120px"
        :rules="personReduceFormRules"
        ref="personReduceForm"
        label-position="right"
      >
        <el-form-item label="人员类别" prop="userTypeId">
          <el-select
            v-model="personReduceForm.userTypeId"
            class="width80"
            :disabled="operation ? false : true"
            @change="handleSelectPerson"
          >
            <el-option
              v-for="item in personReduceOptions"
              :key="item.id"
              :label="item.userTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-row
          v-for="(item, index) in personReduceForm.feeCategoryList"
          :key="index"
        >
          <el-form-item
            :label="item.name"
            :prop="'feeCategoryList.' + index + '.precentDouble'"
            :rules="personReduceFormRules.morePrecentDoubleName"
          >
            <el-input
              v-model.trim="item.precentDouble"
              auto-complete="off"
              class="width80"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button
          :size="size"
          @click.native="dialogVisiblePersonReduceForm = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          @click.native="submitFeePersonReduceForm"
          :loading="personReduceFormLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "PersonCategoryReduction",
  components: {},
  data() {
    var validate = (rule, value, callback) => {
      if (value < 0) {
        return callback(new Error("不能为空"));
      } else {
        //0-1保留两位小数
        var reg = /^(1|0(\.\d{1,2})?)$/;
        if (!reg.test(value)) {
          callback(new Error("请输入0-1之间的两位小数"));
        } else {
          callback();
        }
      }
    };
    return {
      size: "medium", //按钮的尺寸
      tableData: [], //表格的数据
      itemOptions: [], //每一列的label动态数据
      /* dialog模态框的配置数据 */
      operation: true, //新增还是修改  true为新增  false为修改
      dialogVisiblePersonReduceForm: false, //模态框默认关闭
      personReduceForm: {
        userTypeId: "", //人员类别的id
        feeCategoryList: [], //费用类别的数据
      }, //form表单数据源
      personReduceFormRules: {
        userTypeId: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        morePrecentDoubleName: [
          { required: true, validator: validate, trigger: "blur" },
        ],
      }, //表单项的验证
      personReduceFormLoading: false, //确定按钮加载的loading
      personReduceOptions: [], //人员类别的数据
    };
  },
  methods: {
     //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    /* 关闭弹窗 by xiang */
    closeDialogVisible() {
      //this.$refs['personReduceForm'].resetFields();// by guo 2019-09-26 13:45 修改
      this.$nextTick(() => {
        if (this.$refs.personReduceForm != undefined) {
          this.$refs["personReduceForm"].resetFields();
        }
      });
    },

    /* 新增按钮  弹出新增的dialog模态框 */
    addPersonReduce() {
      // 清除验证和值初始化
      this.$nextTick(() => {
        if (this.$refs.personReduceForm != undefined) {
          this.$refs["personReduceForm"].resetFields();
        }
      });
      this.operation = true;
      this.dialogVisiblePersonReduceForm = true;
      this.personReduceForm = {
        userTypeId: "", //人员类别的id
        feeCategoryList: [], //费用类别的数据
      };
      this.queryPersonCategory();
      this.queryFeeCategory();
    },

    /* 
      人员类别的下拉框
    */
    handleSelectPerson(value) {
      console.log(value);
    },

    /* 
      修改人员减免费用
    */
    handleEdit(index, row) {
      console.log(index, row);
      this.operation = false;
      this.dialogVisiblePersonReduceForm = true;
      this.personReduceForm.userTypeId = row.userTypeId; //回显费用类别的数据
      console.log(
        this.personReduceForm.userTypeId,
        this.personReduceForm.feeCategoryList
      );
      row.list.forEach((item) => {
        console.log(item, "------");
        this.personReduceForm.feeCategoryList.forEach((temp) => {
          //判断tempId相同，就将值赋给this.personReduceForm.feeCategoryList数组里面的id
          if (item.itemId == temp.itemId) {
            temp.id = item.id;
            temp.precentDouble = item.precent / 100; //将数据除100，得到小数
          }
        });
      });
      console.log(
        this.personReduceForm.feeCategoryList,
        "this.personReduceForm.feeCategoryList处理后的数据"
      );
    },

    /* 
      人员类别减免提交数据
    */
    submitFeePersonReduceForm() {
      console.log(this.$refs.personReduceForm);
      this.$refs.personReduceForm.validate((valid) => {
        if (valid) {
          console.log(this.personReduceForm);
          let params = new Object();
          let oldManTypeIetypeList = new Array();
          this.personReduceForm.feeCategoryList.forEach((item) => {
            console.log(item);
            /* this.operation 为 true是新增  false为修改 */
            if (this.operation == true) {
              //新增的时候不提交人员类别减免id
              oldManTypeIetypeList.push({
                userTypeId: this.personReduceForm.userTypeId,
                itemId: item.itemId,
                precentDouble: String(item.precentDouble),
              });
            } else {
              //修改的时候需要提交人员类别减免id
              oldManTypeIetypeList.push({
                userTypeId: this.personReduceForm.userTypeId,
                itemId: item.itemId,
                precentDouble: String(item.precentDouble),
                id: item.id,
              });
            }
          });
          params.oldManTypeIetypeList = oldManTypeIetypeList;
          console.log(params);
          this.personReduceFormLoading = true;
          console.log(
            this.personReduceForm.feeCategoryList,
            "this.personReduceForm.feeCategoryList"
          );
          this.$postJson(
            "omc/expenseMiti/addAndUpdate",
            params
          ).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.$refs["personReduceForm"].resetFields();
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            //this.queryFeeCategory();//刷新费用类别  by guo 2019-09-26 14:04注释掉 有bug  刷新表格的时候会出现重复的数据
            this.showAllExpenseMiti(); //刷新表格的数据
            this.personReduceFormLoading = false;
            this.dialogVisiblePersonReduceForm = false;
          });
        }
      });
    },

    /* 
      获取人员类别 
    */
    queryPersonCategory() {
      let params = new Object();
      params.pageNum = 0;
      params.pageSize = 0;
      console.log(params);
      this.personReduceOptions = []; //清空数据，防止累加
      this.$postJson(
        "omc/userType/queryListWithPage",
        params
      ).then((res) => {
        console.log(res, "查询人员类别");
        if (res.code == 200) {
          if (res.result.list.length > 0) {
            res.result.list.forEach((item) => {
              console.log(item);
              this.personReduceOptions.push({
                userTypeName: item.userTypeName,
                id: item.id,
              });
            });
          }
          console.log(this.personReduceOptions);
        }
      });
    },

    /* 
      获取费用类别
    */
    queryFeeCategory() {
      this.personReduceForm.feeCategoryList = []; //清空数据，防止累加
      this.itemOptions = []; //清空数据，防止累加
      this.$postJson("omc/expenseType/queryAll").then(
        (res) => {
          console.log(res, "查询费用类别");
          if (res.code == 200) {
            if (res.result != null || res.result.length > 0) {
              res.result.forEach((item, index) => {
                console.log(item);
                this.personReduceForm.feeCategoryList.push({
                  name: item.name,
                  itemId: item.id,
                  precentDouble: 0,
                  id: "",
                }); //处理得到第一列人员类别的数据
                let itemObj = new Object();
                itemObj.id = index;
                itemObj.title = item.name;
                itemObj.key = "precent" + index;
                this.itemOptions.push(itemObj); //处理得到表格每一列的label的数据
              });
            }
            console.log(this.itemOptions, "----");
            console.log(this.personReduceForm.feeCategoryList);
          }
        }
      );
    },

    /* 
      查询人员类别减免列表
    */
    showAllExpenseMiti() {
      this.queryFeeCategory();
      this.tableData = []; //清空数据，防止累加
      this.itemOptions = []; //清空数据，防止累加
      setTimeout(() => {
        this.$postJson(
          "omc/expenseMiti/showAllExpenseMiti"
        ).then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (res.result != null || res.result.length > 0) {
              res.result.forEach((item) => {
                console.log(item, "item");
                let tableObj = new Object(); //new一个对象
                tableObj.userTypeId = item.userTypeId; //将值赋给对象的这个属性
                tableObj.userTypeName = item.userTypeName; //将值赋给对象的这个属性

                //by guo 新添加了一个flag字段用于下面的判断  因为有的费用类别是新增  而没有通过新增来生成   造成没有新增费用类别的人员类别数据显示错误
                //listNew为新添加的数组
                console.log(
                  item.list,
                  item.list.length,
                  this.personReduceForm.feeCategoryList
                );
                if (
                  item.list.length ==
                  this.personReduceForm.feeCategoryList.length
                ) {
                  tableObj.flag = true;
                  item.listNew = new Array();
                  this.personReduceForm.feeCategoryList.forEach((m) => {
                    let personObject = new Object();
                    item.list.forEach((n) => {
                      if (m.itemId == n.itemId) {
                        personObject.groupId = n.groupId;
                        personObject.id = n.id;
                        personObject.itemId = n.itemId;
                        personObject.itemName = n.itemName;
                        personObject.precent = n.precent;
                        personObject.userTypeId = n.userTypeId;
                        item.listNew.push(personObject);
                      }
                    });
                  });
                } else {
                  tableObj.flag = false;
                }
                console.log(tableObj.flag, "tableObj.flag", item.listNew);
                tableObj.list = new Array();
                if (item.list.length > 0) {
                  if (tableObj.flag == true) {
                    //第二层循环遍历处理数据格式
                    item.listNew.forEach((temp, i) => {
                      //by guo 2019-11-27-15:58 修改 item数据源变更为listNew数据源
                      //item.list.forEach((temp,i)=>{
                      console.log(temp, "temp");
                      if (item.userTypeId == temp.userTypeId) {
                        tableObj["value" + i] = temp; //动态的给对象赋值
                        tableObj["precent" + i] = temp.precent.toFixed(2) + "%"; //动态的给对象赋值 用于回显 格式为0.00%-100.00%
                        tableObj.list.push(temp); //将值添加进数组
                      }
                    });
                  } else {
                    console.log(
                      this.personReduceForm.feeCategoryList,
                      "this.personReduceForm.feeCategoryList",
                      item.list
                    );
                    item.list.forEach((temp, i) => {
                      this.personReduceForm.feeCategoryList.forEach(
                        (fee, j) => {
                          if (temp.itemId == fee.itemId) {
                            tableObj["value" + j] = temp; //动态的给对象赋值
                            tableObj["precent" + j] =
                              temp.precent.toFixed(2) + "%"; //动态的给对象赋值 用于回显 格式为0.00%-100.00%
                            tableObj.list.push(temp); //将值添加进数组
                          } else {
                            tableObj["precent" + j] =
                              fee.precentDouble.toFixed(2) + "%"; //动态的给对象赋值 用于回显 格式为0.00%-100.00%
                          }
                        }
                      );
                    });
                  }
                }
                //by guo 2019-09-06 14:41 修改   判断一下该人员类别是否有费用类别  有费用类别才将其添加进数组中
                if (tableObj.list.length > 0) {
                  this.tableData.push(tableObj); //将值添加进table表格的数组中
                }
              });
              console.log(this.tableData, "this.tableData", this.itemOptions);
            }
          }
        });
      }, 100);
    },
  },
  created() {
    this.queryPersonCategory();
    // this.queryFeeCategory();//注释掉 放在另外一个方法里面去调取
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.showAllExpenseMiti();
      }, 100);
    });
  },
};
</script>
<style lang="scss" scoped>
//  ::v-deep深度作用选择符
  ::v-deep .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
  }
</style>